/** Friendly CMS login / forgot-password messages for the backend's error texts. */
const FRIENDLY_MESSAGES: Record<string, string> = {
  'Cannot find admin user with entered email':
    'No admin account found with this email. Please check it for typos.',
  'User does not exist for entered email':
    'No admin account found with this email. Please check it for typos.',
  'Invalid password entered': 'Incorrect password. Please try again or use "Forgot password?".',
};

export const getLoginErrorMessage = (message: unknown): string => {
  const text = Array.isArray(message) ? message.filter(Boolean).join(', ') : message;
  if (typeof text !== 'string' || !text.trim()) {
    return 'Something went wrong. Please try again.';
  }

  return FRIENDLY_MESSAGES[text] || text;
};
